<form *ngIf="!submitted" [formGroup]="form" (ngSubmit)="submit()" class="modal-main my-modal">
    <div class="modal-head my-modal__header">
        <h1>Add Mask</h1>
    </div>
    <div class="my-modal__flex">
        <div class="my-modal__flex_basis">
            <h3>Mask Name:</h3>
        </div>
        <div class="my-modal__flex_basis form-group">
            <input type="text" formControlName="maskName" class="form-control">
            <small *ngIf="maskName">Please enter Mask Name.</small>
        </div>
        <div class="my-modal__flex_basis">
            <h3>Mask Number:</h3>
        </div>
        <div class="my-modal__flex_basis form-group">
            <input type="text" formControlName="maskNumber" class="form-control">
            <small *ngIf="maskNumber">Please enter valid Mask Number.</small>
        </div>
        <div class="my-modal__flex_basis">
            <h3>Description:</h3>
        </div>
        <div class="my-modal__flex_basis form-group">
            <input type="text" formControlName="description" class="form-control">
        </div>
        <div class="my-modal__button">
            <app-button type="submit">Save</app-button>
        </div>
    </div>
</form>

<form *ngIf="submitted" [formGroup]="form" (ngSubmit)="close()" class="modal-main my-modal">
    <div class="modal-head my-modal__header">
        <h1>Add Mask</h1>
    </div>
    <div class="my-modal__icon">
        <img src="assets/images/popup.png">
    </div>
    <div class="modalbody my-modal__text">
        <p>Mask saved successfully.</p>
    </div>
    <div class="my-modal__button">
        <app-button type="submit">OK</app-button>
    </div>
</form>